import React, { useCallback, useState } from 'react';
import UploadIcon from '@starflow/app/svg-components/upload';
import { usePickFile, useUploadFile } from '@starflow/app/hooks/useUpload';
import { setTempState, getTempState } from '@starflow/app/store';
import { applyInputToNode } from '@starflow/app/helpers/flow';
import { formatSourceElement } from '@starflow/app/utils';
import { Loader } from '@mantine/core';
import emptyIcon from './assets/empty.svg';
import changeImageIcon from './assets/change-image.svg';

const Item = React.memo(({ unitId, data, replaceListIndex, imageListIndex }) => {
  const { handlePickFile } = usePickFile();
  const { handleUploadFile, loading } = useUploadFile();
  const [isHover, setIsHover] = useState(false);

  const handleUpload = useCallback(async () => {
    if (loading) return;
    const file = await handlePickFile();
    if (!file) return;

    const result = await handleUploadFile(file);
    console.log('[DEBUG] ~ handleUpload ~ result:', result);

    const replaceList = [...getTempState('replaceList')];
    replaceList[replaceListIndex].imageList[imageListIndex] = replaceList[replaceListIndex].imageList[
      imageListIndex
    ].map((item) => {
      item.value = {
        ...(item.value ?? {}),
        ...result,
      };
      return item;
    });

    setTempState('replaceList', replaceList);
    data.forEach((item) => {
      applyInputToNode(unitId, item.name, formatSourceElement(result));
    });
  }, [handlePickFile, handleUploadFile, loading]);

  return (
    <>
      <div className="w-full bg-[#252525] rounded-sm flex items-center justify-between mt-2 p-3">
        <div className="w-[48px] h-[48px] bg-[#2C2C2C] rounded-sm mr-3 overflow-hidden relative">
          {data?.[0]?.value?.url ? (
            <div
              className="w-full h-full relative"
              onMouseOver={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <img src={data[0].value.url} alt="" className="w-full h-full object-cover" />
              {loading ? (
                <div className="absolute top-0 left-0 z-[1] flex items-center justify-center w-full h-full">
                  <Loader size={18} />
                </div>
              ) : isHover ? (
                <div
                  className="absolute top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center cursor-pointer"
                  onClick={handleUpload}
                >
                  <img src={changeImageIcon} alt="" className="w-4 h-4" />
                </div>
              ) : null}
            </div>
          ) : (
            <div className="absolute top-0 left-0 w-full h-full cursor-pointer" onClick={handleUpload}>
              <img src={emptyIcon} className="absolute top-0 left-0 w-full h-full" />
              <div className="relative z-[1] flex items-center justify-center w-full h-full">
                {loading ? <Loader size={18} /> : <UploadIcon />}
              </div>
            </div>
          )}
        </div>
        <div className="flex-1">
          <h3 className="text-[12px] leading-[20px]">上传图片用于替换以下参数</h3>
          <p className="text-[12px] leading-[26px] opacity-40">{data.map((item) => item.label).join(' | ')}</p>
        </div>
      </div>
    </>
  );
});

export default Item;
